import { render, staticRenderFns } from "./TheBarraSuperior.vue?vue&type=template&id=6913a180&"
import script from "./TheBarraSuperior.vue?vue&type=script&lang=js&"
export * from "./TheBarraSuperior.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports